import {
  useState,
  useEffect,
  useCallback,
  useMemo,
} from "react";

import { getTodayReading } from "@/lib/biblePlan";
import { markLessonStudiedToday, isLessonStudiedToday } from "@/lib/sabbathProgress";
import { markAsReadToday, isReadToday } from "@/lib/readingProgress";

export function useSpiritualProgress() {
  const [read, setRead] = useState(false);
  const [lessonRead, setLessonRead] = useState(false);
  const [loading, setLoading] = useState(true);

  const reading = useMemo(() => getTodayReading(), []);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const [readToday, lessonStudied] = await Promise.all([
          Promise.resolve(isReadToday()),
          Promise.resolve(isLessonStudiedToday()),
        ]);

        if (cancelled) return;

        setRead(readToday);
        setLessonRead(lessonStudied);
      } catch (err) {
        console.error("[SpiritualProgress] load error:", err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();

    return () => { cancelled = true; };
  }, []);

  const markReadingDone = useCallback(() => {
    markAsReadToday();
    setRead(true);
  }, []);

  const markLessonDone = useCallback(() => {
    markLessonStudiedToday();
    setLessonRead(true);
  }, []);

  return {
    reading,
    read,
    lessonRead,
    loading,
    markReadingDone,
    markLessonDone,
  };
}
